import customInput48Classes from "@/styles/CustomInput48.module.css";
import { TextInput } from "@mantine/core";
import { useState } from "react";

interface CheckoutTextInputProps {
  label: string;
  name: string;
  type?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  required?: boolean;
  className?: string;
  placeholder?: string;
  flex?: boolean;
  showValidation?: boolean;
  customValidation?: (value: string) => boolean;
}

export function CheckoutTextInput({
  label,
  name,
  type = "text",
  value,
  onChange,
  onBlur,
  required = false,
  className = "",
  placeholder,
  flex = true,
  showValidation = false,
  customValidation,
}: CheckoutTextInputProps) {
  const [isFocused, setIsFocused] = useState(false);

  // Helper function to determine if label should float
  const shouldFloatLabel = () => {
    return isFocused || (value && value.length > 0);
  };

  const isInvalid =
    showValidation &&
    ((required && (!value || value.trim() === "")) ||
      (customValidation && value && !customValidation(value)));

  // Helper function to get input classes
  const getInputClasses = () => {
    const shouldFloat = shouldFloatLabel();
    return {
      ...customInput48Classes,
      input: `${customInput48Classes.input} ${shouldFloat ? customInput48Classes.inputFocused : ""} ${isInvalid ? "!border-[#c1332b] !border-2 !bg-[#c1332b08]" : ""}`,
      label: `${customInput48Classes.label} ${shouldFloat ? customInput48Classes.labelFloating : ""} ${isInvalid ? "!text-[#c1332b]" : ""}`,
    };
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (onBlur) {
      onBlur();
    }
  };

  return (
    <TextInput
      label={label}
      name={name}
      type={type}
      value={value}
      onChange={e => onChange(e.target.value)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      required={required}
      classNames={getInputClasses()}
      className={`${flex ? "flex-1" : ""} ${className}`.trim()}
      placeholder={placeholder}
      styles={{
        root: {
          position: "relative",
        },
        label: {
          maxWidth: "calc(100% - var(--mantine-spacing-sm))",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      }}
    />
  );
}
